/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speakers_List_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Available speakers" |
*
* @param {Speakers_List_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_list_aria_label = /** @type {((inputs?: Speakers_List_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_List_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Intervenants disponibles")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verfügbare Lautsprecher")
	if (locale === "it") return /** @type {LocalizedString} */ ("Altoparlanti disponibili")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Доступные колонки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Altavoces disponibles")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("演讲嘉宾")
	if (locale === "ja") return /** @type {LocalizedString} */ ("利用可能なスピーカー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपलब्ध वक्ता")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alto-falantes disponíveis")
	return /** @type {LocalizedString} */ ("Available speakers")
});